module.exports = {
  // * We export the same way as previously done in @prisma/client
  // https://github.com/prisma/prisma/pull/12907
  ...require('./generated/prisma-client/default'),
}
